import axios from 'utils/axios';

export const getAllUnits = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    showDisabled = false,
    tags = [],
    startDate = '',
    endDate = '',
    sortField = '',
    sorting = ''
}) => {
    try {
        const formattedTags = tags.toString();
        const response = await axios.get('units/', {
            params: {
                perPage,
                pageNo,
                query,
                showDisabled,
                tags: formattedTags,
                startDate,
                endDate,
                sortField,
                sorting
            }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const createUnit = async (unitData) => {
    try {
        const response = await axios.post('units/', unitData);
        return response.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
};

export const updateUnit = async (unitId, unitData) => {
    try {
        const response = await axios.put(`units/${unitId}`, unitData);
        return response.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
};

export const syncTGASCrapper = async (unitId, unitData) => {
    try {
        const response = await axios.put(`units/sync-tga-scrapper/${unitId}`, unitData);
        return response.data;
    } catch (e) {
        throw new Error(e.response?.data?.message || e.message);
    }
};
